import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')
import firebase from 'firebase/app'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
  	static:{},
  	user:{
      loggedIn: false,
      data: null
    },
    vehicule:{
      completed:false,
      errors:{},
      send:{type:1,text:"Commander ma Carte Grise"},
      show_form_command:false,
      immat:"",
      type_immat:"",
      dpt:"",
      demarche:{
        value:"",
        sigle:"",
        txt:"",
        path:""
      },
      CO2:"",
      DateMEC:"",
      Energie:"",
      Genre:"",
      Marque:"",
      Modele:"",
      PuissCh:"",
      PuissFisc:"",
      Version:"",
      VIN:"",
      PTR:"",
      Genre_misiv:"",
      PTAC_misiv:"",
      Energie_misiv:"",
      TaxeRegionale:"",
      Taxe35cv:"",
      TaxeParafiscale:"",
      TaxeCO2:"",
      TaxeMalus:"",
      TaxeSIV:"",
      TaxeRedevanceSIV:"",
      TaxeTotale:"",
      Prestation:"",
      PrixTotal:"",
      payment:{
        amount:"",
        ref:"",
        statut:""
      },
      show_iframe:false
    }
  },
  gettrs: {
    user(state){
      return state.user
    }
  },
  actions: {
    setInfosPayment({commit, state},ref){
      if(state.vehicule.PrixTotal.toString().split(".")!=state.vehicule.PrixTotal.toString()){
          var amount = state.vehicule.PrixTotal.toString().split(".").join("");
        }else{
          var amount = state.vehicule.PrixTotal;
        }
      var infos = {
        amount:amount,
        ref:ref
      }
      // console.log(infos)
      commit("setInfosPayment",infos);
    },
    fetchStaticData({ commit }) {
  		// console.log("Monted app")
  		var docs = {};

      firebase.auth().signInAnonymously()
      .then(() => {
  		fb.db.collection('documents').get()
  		.then(res => {
  			res.forEach(doc =>{
  				// console.log(doc.data())
  				docs[doc.id] = doc.data()
  			})
  			commit('setStaticData',docs)
  		})
  		.catch(err => {
  			// console.log(err)
  		})
      })
      .catch((error) => {
        // console.log(error)
      });
    },
  	fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
      } else {
        commit("SET_USER", null);
      }
    },
    updateDemarche({commit,state},demarche){
        if(demarche="00"){
          commit(setDemarcheInfo("CTVO"));
        }
    },
    calculPrix({commit,state}){
      firebase.auth().signInAnonymously()
      .then(() => {
        fb.db.collection('documents').doc("Prestations").get()
        .then(res => {
          var demarche = state.vehicule.demarche.sigle;
          var taxes = parseFloat(state.vehicule.TaxeTotale);
          var presta_object = res.data()[demarche];
          var presta_length = Object.keys(presta_object).length;
          // console.log(presta_object)
          for(var i = 1;i<=presta_length;i++){
            // console.log(presta_object[i.toString()])
              if(taxes<=presta_object[i.toString()].taxes){
                var prestation = presta_object[i.toString()].prestation;
                // console.log(prestation);
                // console.log(taxes);
                if(parseFloat(taxes) > 0){
                  var prixTotal = parseFloat(taxes) + parseFloat(prestation);
                }else{
                  var prixTotal = prestation;
                }  
                var prix = {
                  prestation:prestation,
                  prixTotal:parseFloat(prixTotal).toFixed(2).toString()
                }
                //console.log(prix)
                commit("addVehiculePrix",prix);
                return({status:"200",message:"Le calcul du prix total a fonctionné."})
              }else if(i==presta_length){
                var diff = taxes - presta_object[i.toString()].taxes;
                var frais = presta_object[i.toString()].frais * diff
                var prestation = presta_object[i.toString()].prestation + frais;
                var prixTotal = taxes + prestation;
                var prix = {
                  prestation:prestation,
                  prixTotal:parseFloat(prixTotal).toFixed(2).toString()
                }
                //console.log(prix)
                commit("addVehiculePrix",prix);
                return({status:"200",message:"Le calcul du prix total a fonctionné."})
              }
          }
        }).catch(error=>{
          //console.log("CalculPrix a échoué : "+error);
          return ({status:"500",message:"Le calcul du prix total n'a pas fonctionné.",error:error})
        });
      });
    },
    updateMisivVehicule({commit,state}){
      if(state.vehicule.dpt.toString()== ""){state.vehicule.errors.dpt="Le département d'immatriculation' n'est pas connu.";}

      if(state.vehicule.CO2.toString()== ""){state.vehicule.errors.CO2="Le taux d'émission de CO2 du véhicule n'est pas connu.";}

      if(state.vehicule.PuissFisc.toString()== ""){state.vehicule.errors.PuissFisc="La puissance fiscale du véhicule n'est pas connue.";}

      if(state.vehicule.DateMEC.toString()== ""){state.vehicule.errors.DateMEC="La date de mise en circulation du véhicule n'est pas connue.";}

      if(state.vehicule.Genre == "VP"){state.vehicule.Genre_misiv = 1;}
      else if(state.vehicule.Genre == "CTTE" || state.vehicule.Genre == "DERIV VP"){state.vehicule.Genre_misiv = 2;}
      else if(state.vehicule.Genre == "CAM" || state.vehicule.Genre == "TCP" || state.vehicule.Genre == "TRR"){state.vehicule.Genre_misiv = 3;}
      else if(state.vehicule.Genre == "VASP"){state.vehicule.Genre_misiv = 4;}
      else if(state.vehicule.Genre == "MTL" || state.vehicule.Genre == "MTT1" || state.vehicule.Genre == "MTT2"){state.vehicule.Genre_misiv = 5;}
      else if(state.vehicule.Genre == "CL"){state.vehicule.Genre_misiv = 6;}
      else if(state.vehicule.Genre == "QM"){state.vehicule.Genre_misiv = 7;}
      else if(state.vehicule.Genre == "TRA"){state.vehicule.Genre_misiv = 8;}
      else if(state.vehicule.Genre == "REM" || state.vehicule.Genre == "SREM" || state.vehicule.Genre == "RESP"){state.vehicule.Genre_misiv = 9;}
      else if(state.vehicule.Genre == "TM"){state.vehicule.Genre_misiv = 10;}
      else if(state.vehicule.Genre == "CYCL"){state.vehicule.Genre_misiv = 11;}
      else{state.vehicule.errors.Genre="Le genre du véhicule n'est pas connu.";}

      if(state.vehicule.PTR !== ""){
        if(parseInt(state.vehicule.PTR < 3500)){state.vehicule.PTAC_misiv = 1;}
        else if(parseInt(state.vehicule.PTR < 6000)){state.vehicule.PTAC_misiv = 2;}
        else if(parseInt(state.vehicule.PTR < 11000)){state.vehicule.PTAC_misiv = 3;}
        else if(parseInt(state.vehicule.PTR >= 11000)){state.vehicule.PTAC_misiv = 4;}
      }else{state.vehicule.errors.PTR="Le PTAC du véhicule n'est pas connu.";}

      if(state.vehicule.Energie == "GAZOLE" || state.vehicule.Energie == "ESSENCE" || state.vehicule.Energie == "Essence ou diesel"){state.vehicule.Energie_misiv = 1;}
      else if(state.vehicule.Energie == "GPL ou GNV uniquement"){state.vehicule.Energie_misiv = 2;}
      else if(state.vehicule.Energie == "ELECTRIC" || state.vehicule.Energie == "Electricité uniquement"){state.vehicule.Energie_misiv = 3;}
      else if(state.vehicule.Energie == "Hybride (Electricité + essence/diesel/GPL/GNV/Superéthanol)"){state.vehicule.Energie_misiv = 4;}
      else if(state.vehicule.Energie == "Bioéthanol E85"){state.vehicule.Energie_misiv = 5;}
      else if(state.vehicule.Energie == "Bicarburation (Essence+GPL/GNV ou Superéthanol+GPL/GNV)"){state.vehicule.Energie_misiv = 6;}
      else{state.vehicule.errors.Energie="L'energie du véhicule n'est pas connu.";}

      return("updateMisivVehicule a bien fonctionné");
    },
    addVehicule({commit,state,dispatch}, vehicule) {
      return firebase.auth().signInAnonymously()
      .then(() => {
        // console.log("store/action/addVehicule : "+vehicule.immat);
        var infoImmat = firebase.app().functions('europe-west2').httpsCallable('infoImmat');
        return fb.db.collection('immatriculations').doc(vehicule.immat).get().then(immat_doc => {
          if(immat_doc.exists){
            // console.log(immat_doc.data());
            var immat_content = immat_doc.data().content;
            commit("addVehiculeInfos",{
              immat:vehicule.immat,
              type_immat:vehicule.type_immat,
              dpt:vehicule.dpt,
              demarche:vehicule.demarche,
              immat_content:immat_content
            });
            return dispatch("updateMisivVehicule").then(fbVehicule=>{
              //console.log(fbVehicule);
              //console.log(Object.keys(state.vehicule.errors).length)
              if(Object.keys(state.vehicule.errors).length===0){ // = si il n'y a pas d'erreur
                if(state.vehicule.demarche.sigle=="DUP"){
                  if(state.vehicule.type_immat=="siv"){
                    var taxes = {
                      TaxeRegionale:"0",
                      Taxe35cv:"0",
                      TaxeParafiscale:"0",
                      TaxeCO2:"0",
                      TaxeMalus:"0",
                      TaxeSIV:"11",
                      TaxeRedevanceSIV:"2.76",
                      TaxeTotale:"13.76"
                    }
                  }else if(state.vehicule.type_immat=="fni"){
                    var taxes = {
                      TaxeRegionale:"0",
                      Taxe35cv:"0",
                      TaxeParafiscale:"0",
                      TaxeCO2:"0",
                      TaxeMalus:"0",
                      TaxeSIV:"0",
                      TaxeRedevanceSIV:"2.76",
                      TaxeTotale:"2.76"
                    }
                  }
                  commit("addVehiculeTaxesManual",taxes);
                  return dispatch("calculPrix").then(prixCalculated=>{
                    return {status:"200",message:"Les prix ont été calculées avec succès"};
                    }).catch(error =>{
                    return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                  });               
                }else if(state.vehicule.demarche.sigle=="VCEM"||state.vehicule.demarche.sigle=="CCT"){
                  var taxes = {
                    TaxeRegionale:"0",
                    Taxe35cv:"0",
                    TaxeParafiscale:"0",
                    TaxeCO2:"0",
                    TaxeMalus:"0",
                    TaxeSIV:"11",
                    TaxeRedevanceSIV:"2.76",
                    TaxeTotale:"13.76"
                  }
                  commit("addVehiculeTaxesManual",taxes);
                  return dispatch("calculPrix").then(prixCalculated=>{
                    return {status:"200",message:"Les prix ont été calculées avec succès"};
                    }).catch(error =>{
                    return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                  });               
                }else if(state.vehicule.demarche.sigle=="DCA"){
                  // console.log("DCA");
                  if(state.vehicule.type_immat=="siv"){
                    var taxes = {
                      TaxeRegionale:"0",
                      Taxe35cv:"0",
                      TaxeParafiscale:"0",
                      TaxeCO2:"0",
                      TaxeMalus:"0",
                      TaxeSIV:"0",
                      TaxeRedevanceSIV:"0",
                      TaxeTotale:"0"
                    }
                  }else if(state.vehicule.type_immat=="fni"){
                    var taxes = {
                      TaxeRegionale:"0",
                      Taxe35cv:"0",
                      TaxeParafiscale:"0",
                      TaxeCO2:"0",
                      TaxeMalus:"0",
                      TaxeSIV:"0",
                      TaxeRedevanceSIV:"2.76",
                      TaxeTotale:"2.76"
                    }
                  }
                  commit("addVehiculeTaxesManual",taxes);
                  return dispatch("calculPrix").then(prixCalculated=>{
                    return {status:"200",message:"Les prix ont été calculées avec succès"};
                    }).catch(error =>{
                    return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                  });    
                }else if(state.vehicule.demarche.sigle=="CTVO"||state.vehicule.demarche.sigle=="CTVOS"){
                  return infoImmat({
                    type:2,//ECG
                    immat:state.vehicule.immat,
                    demarche:state.vehicule.demarche,
                    dpt:state.vehicule.dpt,
                    CO2:state.vehicule.CO2,
                    DateMEC:state.vehicule.DateMEC,
                    Puissance:state.vehicule.PuissFisc,
                    Genre:state.vehicule.Genre_misiv,
                    PTAC:state.vehicule.PTAC_misiv,
                    Energie:state.vehicule.Energie_misiv,
                  }).then(result_infoImmat => {
                    //console.log(result_infoImmat.data);
                    //console.log(result.data.status.charAt(0));
                    commit("addVehiculeTaxes",result_infoImmat.data.output);
                    return dispatch("calculPrix").then(prixCalculated=>{
                      return {status:"200",message:"Les taxes ont été calculées avec succès"};
                    }).catch(error =>{
                        return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                    });               
                  }).catch(error =>{
                    return {status:"502",message:"L'infoImmat type 2 (ECG) n'a pas fonctionné.",error:error};
                  });
                }
              }else{//IL MANQUE DES INFOS DANS FIREBASE - DONC REFAIRE INFO IMMAT
                return infoImmat({
                  type:1,//InfoImmat
                  immat:vehicule.immat,
                }).then(result_infoImmat => {
                  //console.log(result_infoImmat.data);
                  //console.log(result.data.status.charAt(0));
                  //if(result.data.status.charAt(0)==2)
                  commit("addVehiculeInfos",{
                    immat:vehicule.immat,
                    type_immat:vehicule.type_immat,
                    dpt:vehicule.dpt,
                    demarche:vehicule.demarche,
                    immat_content:result_infoImmat.data.output
                  });
                    return dispatch("updateMisivVehicule").then(misivVehicule2=>{
                      // console.log(misivVehicule2);
                      if(Object.keys(state.vehicule.errors).length===0){ // = si il n'y a pas d'erreur
                        if(state.vehicule.demarche.sigle=="DUP"){
                          if(state.vehicule.type_immat=="siv"){
                            var taxes = {
                              TaxeRegionale:"0",
                              Taxe35cv:"0",
                              TaxeParafiscale:"0",
                              TaxeCO2:"0",
                              TaxeMalus:"0",
                              TaxeSIV:"11",
                              TaxeRedevanceSIV:"2.76",
                              TaxeTotale:"13.76"
                            }
                          }else if(state.vehicule.type_immat=="fni"){
                            var taxes = {
                              TaxeRegionale:"0",
                              Taxe35cv:"0",
                              TaxeParafiscale:"0",
                              TaxeCO2:"0",
                              TaxeMalus:"0",
                              TaxeSIV:"0",
                              TaxeRedevanceSIV:"2.76",
                              TaxeTotale:"2.76"
                            }
                          }
                          commit("addVehiculeTaxesManual",taxes);
                          return dispatch("calculPrix").then(prixCalculated=>{
                            return {status:"200",message:"Les prix ont été calculées avec succès"};
                            }).catch(error =>{
                            return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                          });               
                        }else if(state.vehicule.demarche.sigle=="VCEM"||state.vehicule.demarche.sigle=="CCT"){
                          var taxes = {
                            TaxeRegionale:"0",
                            Taxe35cv:"0",
                            TaxeParafiscale:"0",
                            TaxeCO2:"0",
                            TaxeMalus:"0",
                            TaxeSIV:"11",
                            TaxeRedevanceSIV:"2.76",
                            TaxeTotale:"13.76"
                          }
                          commit("addVehiculeTaxesManual",taxes);
                          return dispatch("calculPrix").then(prixCalculated=>{
                            return {status:"200",message:"Les prix ont été calculées avec succès"};
                            }).catch(error =>{
                            return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                          });               
                        }else if(state.vehicule.demarche.sigle=="DCA"){
                          // console.log("DCA");
                          if(state.vehicule.type_immat=="siv"){
                            var taxes = {
                              TaxeRegionale:"0",
                              Taxe35cv:"0",
                              TaxeParafiscale:"0",
                              TaxeCO2:"0",
                              TaxeMalus:"0",
                              TaxeSIV:"0",
                              TaxeRedevanceSIV:"0",
                              TaxeTotale:"0"
                            }
                          }else if(state.vehicule.type_immat=="fni"){
                            var taxes = {
                              TaxeRegionale:"0",
                              Taxe35cv:"0",
                              TaxeParafiscale:"0",
                              TaxeCO2:"0",
                              TaxeMalus:"0",
                              TaxeSIV:"0",
                              TaxeRedevanceSIV:"2.76",
                              TaxeTotale:"2.76"
                            }
                          }
                          commit("addVehiculeTaxesManual",taxes);
                          return dispatch("calculPrix").then(prixCalculated=>{
                            return {status:"200",message:"Les prix ont été calculées avec succès"};
                            }).catch(error =>{
                            return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                          });    
                        }else if(state.vehicule.demarche.sigle=="CTVO"||state.vehicule.demarche.sigle=="CTVOS"){
                          return infoImmat({
                            type:2,//ECG
                            immat:state.vehicule.immat,
                            demarche:state.vehicule.demarche,
                            dpt:state.vehicule.dpt,
                            CO2:state.vehicule.CO2,
                            DateMEC:state.vehicule.DateMEC,
                            Puissance:state.vehicule.PuissFisc,
                            Genre:state.vehicule.Genre_misiv,
                            PTAC:state.vehicule.PTAC_misiv,
                            Energie:state.vehicule.Energie_misiv,
                          }).then(result_ECG => {
                            //console.log(result_ECG.data);
                            //console.log(result.data.status.charAt(0));
                            commit("addVehiculeTaxes",result_ECG.data.output)
                            return dispatch("calculPrix").then(prixCalculated=>{
                              return {status:"200",message:"Les taxes ont été calculées avec succès. "};
                            }).catch(error => {
                              return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                            });
                          }).catch(error =>{
                            return {status:"502",message:"L'infoImmat type 2 (ECG) n'a pas fonctionné.",error:error};
                          });
                        }
                      }else{
                        return {status:"500",message:"state.vehicule.errors n'est pas vide, veuillez renseigner les champs inconnus."}
                      }
                    });
                }).catch(error =>{
                  return {status:"501",message:"L'infoImmat type 1 (InfoImmat) n'a pas fonctionné.",error:error}
                });
              }                          
            });
          }else{
            return infoImmat({
              type:1,//InfoImmat
              immat:vehicule.immat,
            }).then(result_infoImmat => {
              // console.log(result_infoImmat.data);
              //console.log(result.data.status.charAt(0));
              //if(result.data.status.charAt(0)==2)
              commit("addVehiculeInfos",{
                immat:vehicule.immat,
                type_immat:vehicule.type_immat,
                dpt:vehicule.dpt,
                demarche:vehicule.demarche,
                immat_content:result_infoImmat.data.output
              });
                return dispatch("updateMisivVehicule").then(misivVehicule2=>{
                  // console.log(misivVehicule2);
                  if(Object.keys(state.vehicule.errors).length===0){ // = si il n'y a pas d'erreur
                    if(state.vehicule.demarche.sigle=="DUP"){
                      if(state.vehicule.type_immat=="siv"){
                        var taxes = {
                          TaxeRegionale:"0",
                          Taxe35cv:"0",
                          TaxeParafiscale:"0",
                          TaxeCO2:"0",
                          TaxeMalus:"0",
                          TaxeSIV:"11",
                          TaxeRedevanceSIV:"2.76",
                          TaxeTotale:"13.76"
                        }
                      }else if(state.vehicule.type_immat=="fni"){
                        var taxes = {
                          TaxeRegionale:"0",
                          Taxe35cv:"0",
                          TaxeParafiscale:"0",
                          TaxeCO2:"0",
                          TaxeMalus:"0",
                          TaxeSIV:"0",
                          TaxeRedevanceSIV:"2.76",
                          TaxeTotale:"2.76"
                        }
                      }
                      commit("addVehiculeTaxesManual",taxes);
                      return dispatch("calculPrix").then(prixCalculated=>{
                        return {status:"200",message:"Les prix ont été calculées avec succès"};
                        }).catch(error =>{
                        return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                      });               
                    }else if(state.vehicule.demarche.sigle=="VCEM"||state.vehicule.demarche.sigle=="CCT"){
                      var taxes = {
                        TaxeRegionale:"0",
                        Taxe35cv:"0",
                        TaxeParafiscale:"0",
                        TaxeCO2:"0",
                        TaxeMalus:"0",
                        TaxeSIV:"11",
                        TaxeRedevanceSIV:"2.76",
                        TaxeTotale:"13.76"
                      }
                      commit("addVehiculeTaxesManual",taxes);
                      return dispatch("calculPrix").then(prixCalculated=>{
                        return {status:"200",message:"Les prix ont été calculées avec succès"};
                        }).catch(error =>{
                        return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                      });               
                    }else if(state.vehicule.demarche.sigle=="DCA"){
                      // console.log("DCA");
                      if(state.vehicule.type_immat=="siv"){
                        var taxes = {
                          TaxeRegionale:"0",
                          Taxe35cv:"0",
                          TaxeParafiscale:"0",
                          TaxeCO2:"0",
                          TaxeMalus:"0",
                          TaxeSIV:"0",
                          TaxeRedevanceSIV:"0",
                          TaxeTotale:"0"
                        }
                      }else if(state.vehicule.type_immat=="fni"){
                        var taxes = {
                          TaxeRegionale:"0",
                          Taxe35cv:"0",
                          TaxeParafiscale:"0",
                          TaxeCO2:"0",
                          TaxeMalus:"0",
                          TaxeSIV:"0",
                          TaxeRedevanceSIV:"2.76",
                          TaxeTotale:"2.76"
                        }
                      }
                      commit("addVehiculeTaxesManual",taxes);
                      return dispatch("calculPrix").then(prixCalculated=>{
                        return {status:"200",message:"Les prix ont été calculées avec succès"};
                        }).catch(error =>{
                        return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                      });    
                    }else if(state.vehicule.demarche.sigle=="CTVO"||state.vehicule.demarche.sigle=="CTVOS"){
                      return infoImmat({
                        type:2,//ECG
                        immat:state.vehicule.immat,
                        demarche:state.vehicule.demarche,
                        dpt:state.vehicule.dpt,
                        CO2:state.vehicule.CO2,
                        DateMEC:state.vehicule.DateMEC,
                        Puissance:state.vehicule.PuissFisc,
                        Genre:state.vehicule.Genre_misiv,
                        PTAC:state.vehicule.PTAC_misiv,
                        Energie:state.vehicule.Energie_misiv,
                      }).then(result_ECG => {
                        // console.log(result_ECG.data);
                        //console.log(result.data.status.charAt(0));
                        commit("addVehiculeTaxes",result_ECG.data.output)
                        return dispatch("calculPrix").then(prixCalculated=>{
                          return {status:"200",message:"Les taxes ont été calculées avec succès. "};
                        }).catch(error => {
                          return {status:"503",message:"Le calcul du prix des prestations n'a pas fonctionné.",error:error};
                        });
                      }).catch(error =>{
                        return {status:"502",message:"L'infoImmat type 2 (ECG) n'a pas fonctionné.",error:error};
                      });
                    }
                  }else{
                    return {status:"500",message:"state.vehicule.errors n'est pas vide, veuillez renseigner les champs inconnus."}
                  }
                });
            }).catch(error =>{
              return {status:"501",message:"L'infoImmat type 1 (InfoImmat) n'a pas fonctionné.",error:error}
            });
          }

        });
      });
    }
  },
  mutations: {
  setInfosPayment(state,infos){
    state.vehicule.payment.amount=infos.amount,
    state.vehicule.payment.ref=infos.ref
  },
	setStaticData(state,val){
		state.static=val;
		// console.log(state.static);
	},
  addVehiculeInfos(state,datas){
    // console.log("addVehiculeInfos Go");
    state.vehicule.immat=datas.immat;
    state.vehicule.type_immat=datas.type_immat;
    state.vehicule.dpt=datas.dpt;
    if(datas.demarche=="00"){
      state.vehicule.demarche.value="00";
      state.vehicule.demarche.sigle="CTVO";
      state.vehicule.demarche.txt="Changement de Titulaire d'un Véhicule d'Occasion"
      state.vehicule.demarche.path="/immatriculation/carte_grise";
    }else if(datas.demarche=="01"){
      state.vehicule.demarche.value="01";
      state.vehicule.demarche.sigle="DCA";
      state.vehicule.demarche.txt="Changement d'Adresse"
      state.vehicule.demarche.path="/immatriculation/adresse";
    }else if(datas.demarche=="02"){
      state.vehicule.demarche.value="02";
      state.vehicule.demarche.sigle="DUP";
      state.vehicule.demarche.txt="Demande de Duplicata"
      state.vehicule.demarche.path="/immatriculation/duplicata";
    }else if(datas.demarche=="03"){
      state.vehicule.demarche.value="03";
      state.vehicule.demarche.sigle="CCT";
      state.vehicule.demarche.txt="Changement de Caractéristique Technique"
      state.vehicule.demarche.path="/immatriculation/autres_immat";
    }else if(datas.demarche=="04"){
      state.vehicule.demarche.value="04";
      state.vehicule.demarche.sigle="CTVOS";
      state.vehicule.demarche.txt="Changement de Titulaire suite à une Succession"
      state.vehicule.demarche.path="/immatriculation/succession";
    }else if(datas.demarche=="05"){
      state.vehicule.demarche.value="05";
      state.vehicule.demarche.sigle="VCEM";
      state.vehicule.demarche.txt="Veuvage - Changement d'état Matrimonial"
      state.vehicule.demarche.path="/immatriculation/matrimonial";
    }
    if(datas.immat_content.split("<" + "CO2" + ">") != datas.immat_content){state.vehicule.CO2=datas.immat_content.split("<" + "CO2" + ">")[1].split("</" + "CO2" + ">")[0];} 
    if(datas.immat_content.split("<" + "DateMec" + ">") != datas.immat_content){state.vehicule.DateMEC=datas.immat_content.split("<" + "DateMec" + ">")[1].split("</" + "DateMec" + ">")[0];}
    if(datas.immat_content.split("<" + "Energie" + ">") != datas.immat_content){state.vehicule.Energie=datas.immat_content.split("<" + "Energie" + ">")[1].split("</" + "Energie" + ">")[0];}
    if(datas.immat_content.split("<" + "Genre" + ">") != datas.immat_content){state.vehicule.Genre=datas.immat_content.split("<" + "Genre" + ">")[1].split("</" + "Genre" + ">")[0];}
    if(datas.immat_content.split("<" + "Marque" + ">") != datas.immat_content){state.vehicule.Marque=datas.immat_content.split("<" + "Marque" + ">")[1].split("</" + "Marque" + ">")[0];}
    if(datas.immat_content.split("<" + "Modele" + ">") != datas.immat_content){state.vehicule.Modele=datas.immat_content.split("<" + "Modele" + ">")[1].split("</" + "Modele" + ">")[0];}
    if(datas.immat_content.split("<" + "PuissCh" + ">") != datas.immat_content){state.vehicule.PuissCh=datas.immat_content.split("<" + "PuissCh" + ">")[1].split("</" + "PuissCh" + ">")[0];}
    if(datas.immat_content.split("<" + "PuissFisc" + ">") != datas.immat_content){state.vehicule.PuissFisc=datas.immat_content.split("<" + "PuissFisc" + ">")[1].split("</" + "PuissFisc" + ">")[0];}
    if(datas.immat_content.split("<" + "Version" + ">") != datas.immat_content){state.vehicule.Version=datas.immat_content.split("<" + "Version" + ">")[1].split("</" + "Version" + ">")[0]}
    if(datas.immat_content.split("<" + "VIN" + ">") != datas.immat_content){state.vehicule.VIN=datas.immat_content.split("<" + "VIN" + ">")[1].split("</" + "VIN" + ">")[0];}
    if(datas.immat_content.split("<" + "PTR" + ">") != datas.immat_content){state.vehicule.PTR=datas.immat_content.split("<" + "PTR" + ">")[1].split("</" + "PTR" + ">")[0];}
    state.vehicule.completed=true;
    // console.log({addVehiculeInfos:state.vehicule});
  },
  addVehiculeTaxes(state,result){
    // console.log("addVehiculeTaxes Go");
    state.vehicule.TaxeRegionale=result.split("<" + "TaxeRegionale" + ">")[1].split("</" + "TaxeRegionale" + ">")[0];
    state.vehicule.Taxe35cv=result.split("<" + "Taxe35cv" + ">")[1].split("</" + "Taxe35cv" + ">")[0];
    state.vehicule.TaxeParafiscale=result.split("<" + "TaxeParafiscale" + ">")[1].split("</" + "TaxeParafiscale" + ">")[0];
    state.vehicule.TaxeCO2=result.split("<" + "TaxeCO2" + ">")[1].split("</" + "TaxeCO2" + ">")[0];
    state.vehicule.TaxeMalus=result.split("<" + "TaxeMalus" + ">")[1].split("</" + "TaxeMalus" + ">")[0];
    state.vehicule.TaxeSIV=result.split("<" + "TaxeSIV" + ">")[1].split("</" + "TaxeSIV" + ">")[0];
    state.vehicule.TaxeRedevanceSIV=result.split("<" + "TaxeRedevanceSIV" + ">")[1].split("</" + "TaxeRedevanceSIV" + ">")[0];
    state.vehicule.TaxeTotale=result.split("<" + "TaxeTotale" + ">")[1].split("</" + "TaxeTotale" + ">")[0];
    // console.log({addVehiculeTaxes:state.vehicule});
  },
  addVehiculeTaxesManual(state,taxes){
    // console.log("addVehiculeTaxesManual Go");
    state.vehicule.TaxeRegionale=taxes.TaxeRegionale;
    state.vehicule.Taxe35cv=taxes.Taxe35cv;
    state.vehicule.TaxeParafiscale=taxes.TaxeParafiscale;
    state.vehicule.TaxeCO2=taxes.TaxeCO2;
    state.vehicule.TaxeMalus=taxes.TaxeMalus;
    state.vehicule.TaxeSIV=taxes.TaxeSIV;
    state.vehicule.TaxeRedevanceSIV=taxes.TaxeRedevanceSIV;
    state.vehicule.TaxeTotale=taxes.TaxeTotale;
    // console.log({addVehiculeTaxes:state.vehicule});
  },
  addVehiculePrix(state,prix){
    // console.log("CALCULON LE PRIX DE SUITE");
    state.vehicule.Prestation = prix.prestation.toString();
    state.vehicule.PrixTotal = prix.prixTotal.toString();
    // console.log({addVehiculePrix:state.vehicule});
  },
  cleanVehicule(state){
    state.vehicule = {
      completed:false,
      errors:{},
      send:{type:1,text:"Commander ma Carte Grise"},
      show_form_command:false,
      immat:"",
      type_immat:"",
      dpt:"",
        demarche:{
        value:"",
        sigle:"",
        txt:"",
        path:""
      },
      CO2:"",
      DateMEC:"",
      Energie:"",
      Genre:"",
      Marque:"",
      Modele:"",
      PuissCh:"",
      PuissFisc:"",
      Version:"",
      VIN:"",
      PTR:"",
      Genre_misiv:"",
      PTAC_misiv:"",
      Energie_misiv:"",
      TaxeRegionale:"",
      Taxe35cv:"",
      TaxeParafiscale:"",
      TaxeCO2:"",
      TaxeMalus:"",
      TaxeSIV:"",
      TaxeRedevanceSIV:"",
      TaxeTotale:"",
      Prestation:"",
      PrixTotal:"",
      payment:{
        amount:"",
        ref:"",
        statut:""
      },
      show_iframe:false
    }
  },
	SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
      // console.log(state.user)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js